<template>
<div>
<v-toolbar light>
    <v-toolbar-title @click="goFirstPage()">
        <img src="../assets/Pos/weserve-logo.png" alt="weserve-logo" width="200px" style="cursor:pointer;margin-top:8px;">
    </v-toolbar-title>
</v-toolbar>
<div id="bg">
    
  <v-layout justify-center class="hidden-xs-only">
  <v-card flat color="transparent" class="text-xs-center">
  <span class="oop">{{ $t('front_web.error404Content_0')}}</span>
      <div class="font404">
      <p>&#8220;{{ $t('front_web.error404Content_1')}} </p>
        <p> {{ $t('front_web.error404Content_2')}} </p>
        <p> {{ $t('front_web.error404Content_3')}} </p>
        <p> {{ $t('front_web.error404Content_4')}}&#8221;</p>
        </div> 
        <v-btn color="#ffd600" @click="goFirstPage()">{{ $t('front_web.backToHome')}}</v-btn>

        <!-- <nuxt-link :to="localePath('index')" style="text-decoration:none;">
        <v-btn color="#ffd600" style="font-family: 'SukhumvitSet-Light';">{{ $t('front_web.backToHome')}}</v-btn>
        </nuxt-link> -->
  </v-card>
  </v-layout>  
  <div class="hidden-sm-and-up">
  <v-flex class="oop-m text-xs-center">{{ $t('front_web.error404Content_0')}}</v-flex>
  <v-layout justify-center>
  <v-card flat color="transparent">
      <div class="font404-m">
      <p>&#8220;{{ $t('front_web.error404Content_mobile')}}&#8221;</p>
      </div> 
  </v-card>
  </v-layout>
  <v-flex class="text-xs-center">
   <!-- <nuxt-link to="/" style="text-decoration:none;">
   <v-btn color="#ffd600" 
        style="font-family:'SukhumvitSet-Light';">{{ $t('front_web.backToHome')}}
  </v-btn>
   </nuxt-link> -->
  </v-flex>
  </div> 
 </div>
 <v-footer app class="pa-3">
    <v-spacer></v-spacer>
    <div>&copy; 2019 Powered by WESERVE</div>
 </v-footer>
 </div>
</template>
<script>
// import Carousel from '~/components/Carousel.vue'
  export default {
    data() {
      return {
      }
    },
    // components: {
    //   Carousel
    // },
    mounted(){
    //     let _this = this;
    //   setTimeout(function(){
    //   _this.$router.push(_this.localePath('index'));
    //   }, 10000);
    },
    methods: {
    goFirstPage() {
        this.$router.push({path : '/'})
    }
}
  }
</script>
<style scoped>
/* @font-face {
  font-family: 'SukhumvitSet-Light';
      src: url('/SukhumvitSet-Light.woff2') format('woff2');
} */
.font404 {
  /* font-family: 'SukhumvitSet-Light'; */
  font-size:25px;
}
.oop {
  /* font-family: 'SukhumvitSet-Light'; */
  font-size:70px;
}
/* mobile */
.font404-m {
  /* font-family: 'SukhumvitSet-Light'; */
  font-size:20px;
  padding: 0 10px;
}
.oop-m {
  /* font-family: 'SukhumvitSet-Light'; */
  font-size:40px;
}
#bg {
    padding: 25px;
    background: url("../assets/bg-error.png");
    background-repeat: no-repeat;
    background-size: cover;
    height: calc(100vh - 64px);
}
</style>
